import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function AboutUs() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      id="about-us"
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } py-10 lg:py-24 relative overflow-hidden bg-[#1a1a1a] lg:h-screen flex items-center justify-center enfinity-subtext-font `}
    >
      {/* Background Video */}
      {/* <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-50 z-0"
      >
        <source
          src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/WEBPAGE-nocard-1080p.mp4"
          type="video/mp4"
        />
      </video>
       */}
      {/* Background image (right side) */}
      <div
        className="absolute inset-0 w-full h-full bg-no-repeat bg-right z-0"
        style={{
          backgroundImage: `url('https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/about-us-img.png')`,
          backgroundSize: "65%",
        }}
      />

      <div className="mx-auto relative z-10 w-full max-w-7xl px-4 xxs:px-6 xs:px-10 sm:px-10 md:px-12 lg:px-6 xl:px-8">
        <div className="text-center mb-16 lg:mb-20 relative z-20">
          <p className="text-[#757575] text-xs xxs:text-sm xs:text-sm sm:text-sm md:text-lg lg:text-lg 4xl:text-[24px] font-medium mb-6 xl:pt-12 enfinity-subtext-font">
            What we can offer you
          </p>
          <p className="text-4xl xxs:text-4xl lg:text-5xl xxs:px-10 xs:px-10 sm:px-10 md:px-10 lg:px-20 xl:px-0 xl:text-6xl 4xl:text-[65px] font-normal text-white text-center max-w-5xl mx-auto leading-tight xxs:leading-[1.8] xs:leading-[1.6] sm:leading-[1.5] md:leading-[1.5] 4xl:leading-[1.2] enfinity-header-font" style={{ lineHeight: "1.3" }}>
            <span className="text-white">Enfinity helps content creators </span>
            <span className="font-semibold text-[#00d115]">grow,</span>
            <span className="text-white"> </span>
            <span className="font-semibold text-[#9c44e9]">protect,</span>
            <span className="text-white"> and </span>
            <span className="font-semibold text-[#00b0ff]">earn more</span>
            <span className="text-white">
              {" "}
              from their videos. We provide tools for faster payouts, copyright
              protection, content distribution, and channel growth so creators
              can focus on creating while we handle the rest.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

